import { render, staticRenderFns } from "./NextHopGroupShow.vue?vue&type=template&id=4531701a&"
import script from "./NextHopGroupShow.vue?vue&type=script&lang=js&"
export * from "./NextHopGroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports